import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ListItemLink } from '@wix/da-ds/pkg/List/ListItem';
import { BiData, ManageSubscriptionBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  deviation: PapiDeviation;
}

const ManageTier: React.FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();

  return (
    <ListItemLink
      label={t('deviationview.tierCard.moreActionsMenu.item.unsubscribe')}
      href={Url.account(deviation.deviationId)}
      biData={BiData<ManageSubscriptionBiEvent>({
        evid: 560,
        subscription_type: 'subscription',
      })}
    />
  );
};
ManageTier.displayName = 'ManageTier';

export default ManageTier;
